import React, { useEffect, useRef } from "react";
import "./HomeDashboard.css";
import user from "../../../../Image/user.jpg";
import Dashboard from "../../AdminDashboard/Dashboard/Dashboard";
import Navbar from "../../../Shard/Navbar/Navbar";
import { Link, Outlet } from "react-router-dom";
import Footer from "../../../Shard/Footer/Footer";

const HomeDashboard = ({ isShaws, setIsShaws }) => {
  const ref = useRef(null);
  const isAdmin = false;
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsShaws(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
  return (
    <div>
      <Navbar isShaws={isShaws} setIsShaws={setIsShaws} />
      {!isAdmin && (
        <div className="dashboardMain">
          <div className={isShaws ? "sidebarBefore" : "sidebarAfter"}>
            <div className="dashboard">
              <div className="userMenuItems">
                <div className="userProfile">
                  <img src={user} alt="" className="userImg" />
                  <h6 className="user_Name">Raju Molla</h6>
                </div>
                <h4 className="overview">Overview</h4>
                <div className="adminDashboardMenu" ref={ref}>
                  <ul>
                    <li>
                      <Link to={"/dashboard/my-req"}>My Request</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <div className="sidebarMain">
              <SideBar />
            </div> */}
          </div>
          <div className={isShaws ? "userTabBefor " : "userTabAfter"}>
            <Outlet />
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default HomeDashboard;
